import React, { useCallback, useState, useEffect, useRef, useMemo } from "react";
import PinInput from "react-pin-input";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  ApiKey,
  ApiUrl,
  WebUrl,
  SessionKey,
  Language,
  LanguageOption,
  _MAIN_WALLET_ID,
  AlertTypes,
} from "../../../util/Constant";
import { useTranslation } from "react-i18next";
import ApiEngine from "../../../util/ApiEngine.js";
import {
  showResponseMessage,
  setBusy,
  setIdle,
  bindMember,
  bindGames,
  showMessage,
} from "../../../redux/AppAction.js";
import { saveLanguageId } from "../../../redux/LanguageAction";
import {
  Modal,
  ModalBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
} from "reactstrap";
import {
  stringIsNullOrEmpty,
  isObjectEmpty,
  numberWithCurrencyFormat,
  createFormBody,
  createMultiPartFormBody
} from "../../../util/Util";
import Spinner from "react-bootstrap/Spinner";
import classnames from "classnames";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { useForm, Controller } from "react-hook-form";
import Numpad from "../../../components/custom/Numpad";
import moment from "moment";
import UMIcon2 from "../../../assets/img/icon/um2.svg";
import "swiper/swiper-bundle.min.css";
import Slider from "react-slick";
import parse from "react-html-parser";
import SweetAlert from "react-bootstrap-sweetalert";
import { mdiContentCopy } from "@mdi/js";
import Icon from "@mdi/react";
import QRCode from "qrcode.react";
import { themeIcons } from "config/theme";
import VIcon from "components/custom/Icon";
import Cookies from "universal-cookie";
import { InlineShareButtons } from "sharethis-reactjs";
import { map } from "lodash";

/// <summary>
/// Author: -
/// </summary>
const Dashboard = (props) => {
  const { t, i18n } = useTranslation();
  const _history = useHistory();
  const _dispatch = useDispatch();
  const _ = require("lodash");
  let _userData = useSelector((state) => state.authState.userData);
  const [balanceAndCommissionActive, setBalanceAndCommissionActive] =
    useState(1);
  const [hideBalanceAndCommission, setHideBalanceAndCommission] =
    useState(false);
  const memberData = useSelector((state) => state.appState.member);
  var { isLoggedIn } = useSelector((state) => state.authState);

  const [games, setGames] = useState(
    useSelector((state) => state.appState.games)
  );
  const [isNewWindow, setIsNewWindow] = useState(false);
  const [gameCategories, setGameCategories] = useState([
    { id: -1, title: "All" },
    { id: 3, title: "Slots" },
    { id: 5, title: "Casino" },
    { id: 6, title: "Fish Hunt" },
    { id: 7, title: "Lottery" },
    { id: 4, title: "Sports" },
  ]);

  const [activeTab, setActiveTab] = useState(-1);
  const [theInterval, setTheInterval] = useState(false);
  const [invalidPin, setInvalidPin] = useState(false);
  const [pinNumberFinal, setPinNumberFinal] = useState("");
  const [enteredPinNumberFinal, setEnteredPinNumberFinal] = useState("");
  const [pinNumberFinalFocused, setPinNumberFinalFocused] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [showPinEntry, setShowPinEntry] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [smsSent, setSmsSent] = useState(false);
  const [unclaimComm, setUnclaimComm] = useState("");
  const [showPregamePopup, setShowPregamePopup] = useState(false);
  const [fromOptions, setFromOptions] = useState([]);
  const [toOptions, setToOptions] = useState([]);
  const [currentInput, setCurrentInput] = useState();
  const [productGameId, setProductGameId] = useState(0);
  const [masterProductId, setMasterProductId] = useState(0);
  const [isTransferSuccess, setIsTransferSuccess] = useState(false);
  const [popupBannerImage, setPopupBannerImage] = useState("");
  const [bonus, setBonus] = useState(0);
  const [selectedGameName, setSelectedGameName] = useState("");
  const [mpData, setMpData] = useState([]);
  const [isApp, setIsApp] = useState(false);
  const [toLobbyBtn, SetToLobbyBtn] = useState(false);
  const [appUrl, setAppUrl] = useState("");
  const [appDeepLink, setAppDeepLink] = useState("");
  const [selectedGameHasOwnLobby, setSelectedGameHasOwnLobby] = useState(false);
  const [selectedGameIsSeamless, setSelectedGameIsSeamless] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  let usernameRef = useRef();
  let passwordRef = useRef();

  const _COUNTDOWN_PERIOD = 120;
  const _SECONDS_IN_MS = 1000;
  const _ALERT_TIMEOUT = 3000;
  const _FIRST_TAB = 1;
  const _SECOND_TAB = 2;
  const [countdownPeriod, setCountdownPeriod] = useState(0);
  const [transferShow, setTransferShow] = useState(false);
  const [gameActiveTab, setGameActiveTab] = useState(_FIRST_TAB);
  const [gameList, setGameList] = useState([]);
  const [toGameAmount, setToGameAmount] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [promoShow, setPromoShow] = useState(false);
  const [promoId, setPromoId] = useState("");
  const [rolloverBalance, setRolloverBalance] = useState("");
  const [rolloverTarget, setRolloverTarget] = useState("");
  const [content, setContent] = useState("");
  const [appUsername, setAppUsername] = useState("");
  const [appPassword, setAppPassword] = useState("");
  const [showAppCred, setShowAppCred] = useState(false);
  const [unreadNotification, setUnreadNotification] = useState(false);

  const [promoCodeList, setPromoCodeList] = useState([]);
  const [totalComm, setTotalComm] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [productCommRate, setProductCommRate] = useState([]);
  const elePin = useRef(null);
  const eleConfirm = useRef(null);
  const eleFinalPin = useRef(null);
  const keyboard = useRef();
  const [banners, setBanners] = useState([]);
  const [unclaimPoints, setUnclaimPoints] = useState("");
  const [dCRate, setDCRate] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const [claimed, setClaimed] = useState(false);
  const [countdownText, setCountdownText] = useState("");
  const [showDCPopup, setShowDCPopup] = useState(false);
  const [registerUrl, setRegisterUrl] = useState("");
  const [qrModal, setQRModal] = useState(false);
  const [referralCodeDetail, setReferralCodeDetail] = useState([]);
  const _APPEND_REGISTER_URL = WebUrl._URL_MLMCREATEANACCOUNT + "?code=";
  const [uplineUsername, setUplineUsername] = useState("");
  const [dragging, setDragging] = useState(false);

  var _cookies = new Cookies();
  const [dropdownLanguageOpen, setDropdownLanguageOpen] = useState(false);
  const [languageSelected, setLanguageSelected] = useState({
    name: "Khmer",
    code: "kh",
  });
  const {
    handleSubmit: handleSubmitPopup,
    register: registerPopup,
    control: controlPopup,
    watch: watchPopup,
    getValues: getValuesPopup,
    setValue: setValuePopup,
    errors: errorsPopup,
    reset: resetPopup,
  } = useForm();

  const [bonusWalletBalance, setBonusWalletBalance] = useState(0);
  const [showPromo, setShowPromo] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState([]);
  const [isPromoCleared, setIsPromoCleared] = useState(false);
  const [showRestoreAccBlanceConfirmation, setShowRestoreAccBlanceConfirmation] = useState(false);
  const [isBonusWalletRestored, setIsBonusWalletRestored] = useState(false);
  const [isValidForPromotion, setIsValidForPromotion] = useState(false);
  const [selectedGame, setSelectedGame] = useState([]);
  const [isActivedPromoExist, setIsActivePromoExist] = useState(false);

  const [isBonusWallet, setIsBonusWallet] = useState(false)
  const [tempBonusWallet, setTempBonusWallet] = useState(0);
  const [tempMainWallet, setTempMainWallet] = useState(0);
  const [bonusTarget, setBonusTarget] = useState(0);
  const [maxWithdraw, setMaxWithdraw] = useState(0);
  const [seconds, setSeconds] = useState(-1);
  const [showCodeAlert, setShowCodeAlert] = useState(false);

  /// <summary>
  /// Author : -
  /// </summary>
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const _CLOSE_TAB_KEY = "CLOSE_TAB";
  const _USER_DATA = useSelector((s) => s.authState.userData);

  const [deviceType, setDeviceType] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [commissionInfo, setCommissionInfo] = useState({})

  const [showEndPromoConfirmation, setShowEndPromoConfirmation] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  useEffect(() => {
    setDeviceType(window.navigator.platform);
  }, []);

  useEffect(() => {
    if(rolloverTarget == "" ){
      setIsBonusWallet(false)
    }else{
      setIsBonusWallet(true)
    }
  }, [rolloverBalance,rolloverTarget]);

  const verifyPin = async (pin) => {
    let params = {
      pinNumber: pin,
    };
    let responseJson = await ApiEngine.post(
      ApiUrl._API_CHECK_SHAREHOLDER_PIN_NUMBER,
      createFormBody(params)
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setInvalidPin(false);
      _history.push(
        WebUrl._URL_SHAREHOLDER +
        "?GAzobE73Vse4nr8WpufA=" +
        memberData["hideSummary"]
      );
    } else {
      setInvalidPin(true);
      setErrorMessage(responseJson[ApiKey._API_MESSAGE_KEY]);
      eleFinalPin["current"].clear();
      setPinNumberFinal("");
      setEnteredPinNumberFinal("");
      setPinNumberFinalFocused(0);
      eleFinalPin["current"]["elements"][0].focus();
    }
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentWalletBalance, setCurrentWalletBalance] = useState(0);
  const [promotionList, setPromotionList] = useState([]);
  const [showPromotionConfirmation, setShowPromotionConfirmation] = useState(false);
  const [isInitLoaded, setIsInitLoaded] = useState(false);

  const [latestDepositList, setLatestDepositList] = useState();
  const [latestWithdrawalList, setLatestWithdrawalList] = useState();
  const [payoutList, setPayoutList] = useState([]);
	const payoutSlick = {
		dots: false,
		infinite: true,
		// centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    draggable: false,
		autoplay: true,
		speed: 1000,
		autoplaySpeed: 3000,
		arrows:false,
  };

  useEffect(() => {
    if (isLoggedIn) {
      init();
      checkDC();
    }
    onClickLanguage(localStorage.getItem(SessionKey._LANGUAGE) ?? Language._KHMER)
    CountDownTimer();
    retrieveGamesData()
    window.addEventListener("message", function (event) {
      if (event.data == _CLOSE_TAB_KEY) {
        event.source.close();
      }
    });
    getRecentPayout();
    getTopDepositWithdrawal();

  }, []);

  const [isMaxed, setIsMaxed] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      if (memberData["commission"]) {
        let data = memberData["commission"];
        setUnclaimComm(data);
      }

      if (memberData["memberPoints"]) {
        let data = memberData["memberPoints"];
        setUnclaimPoints(data);
      }

      if (memberData["username"]) {
        languageHandle();
        isAnyUnreadNotification();
        // getMarqueeTagContent(memberData["languageSetting"]);
        getCommissionData();
        if (localStorage.getItem(SessionKey._LANGUAGE) == "undefined") {
          localStorage.setItem(
            SessionKey._LANGUAGE,
            LanguageOption.filter(
              (option) => option.languageId == memberData["languageSetting"]
            )[0].value
          );
        }
      }
      var totalDeposit =
        memberData["vipInfo"]?.["targetObtainDeposit"] -
        memberData["amountDeposited"];
      if (
        totalDeposit <= 0 &&
        memberData["vipInfo"]?.["vipId"] == memberData["vipInfo"]?.["targetVipId"]
      ) {
        setIsMaxed(true);
      }
    }

  }, [memberData]);


  const languageHandle = async () => {
    // changeLanguage(memberData["languageCode"]);

    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith("language="))
      ?.split("=")[1];

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: "cookie",
          cookie: cookieValue,
        })
      );
    }
    //KT:Why need to call one more time? Different language different product meh?
    //retrieveGamesData(memberData["languageSetting"])
  };
  const retrieveGamesData = async (languageId = "1") => {
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_DASHBOARD_GROUP +
      "?languageId=" +
      languageId
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let tmpGames = responseJson[ApiKey._API_DATA_KEY].sort((a, b) => {
            // Convert to boolean (true = 1, false/null = 0) and sort descending
            return (b.isPromotion === true ? 1 : 0) - (a.isPromotion === true ? 1 : 0);
        });

        console.log(tmpGames);
      setGames(tmpGames);
      _dispatch(bindGames(tmpGames));
      /// preload
      responseJson[ApiKey._API_DATA_KEY].map((game, index) => {
        let image = new Image();
        image.src = game["image"];

        window[game["image"]] = image;
      });
    } else {
      throw responseJson[ApiKey._API_MESSAGE_KEY];
    }
  }

  async function init() {
    if (isLoggedIn) {
      bindMember(_dispatch);
      ApiEngine.get(ApiUrl._API_CHECK_MEMBER_DC).then((responseJson) => {
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
          if (responseJson[ApiKey._API_DATA_KEY] != null) {
            if (!responseJson[ApiKey._API_DATA_KEY]["isTodayCheckIn"]) {
              setTimeout(() => {
                setShowDCPopup(true);
              }, 5000);
            }
          }
        }
      });
    }

  }
  //init END

  async function getMarqueeTagContent(language) {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_MARQUEE_TAG_CONTENT +
      "?MarqueeTagId=1" +
      "&LanguageId=" +
      language
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      responseJson[ApiKey._API_DATA_KEY].map((option) => {
        setContent(option["content"]);
      });
    }
  }

  async function getRestoreAccountBlance() {
    _dispatch(setBusy());
    let responseJson = await ApiEngine.get(ApiUrl._API_RESTORE_MAIN_WALLET);

    _dispatch(
      showResponseMessage(
        responseJson[ApiKey._API_SUCCESS_KEY],
        responseJson[ApiKey._API_MESSAGE_KEY]
      )
    );
    tempUpdateUserData();
    _dispatch(setIdle());
    getPromotion(masterProductId)
  }

  async function getRestore() {
    _dispatch(setBusy());
    let responseJson = await ApiEngine.get(ApiUrl._API_RESTORE_ALL_WALLET);

    _dispatch(
      showResponseMessage(
        responseJson[ApiKey._API_SUCCESS_KEY],
        responseJson[ApiKey._API_MESSAGE_KEY]
      )
    );
    tempUpdateUserData();
    _dispatch(setIdle());
  }

  async function getCommissionData() {
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_COMMISSION_AMT
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];

      let totalComm = _.sumBy(data.data, function (x) {
        return x.totalComm;
      });

      setTotalComm(totalComm);
    }
  }
  
const ShareButton = useMemo(() => {
	if (!stringIsNullOrEmpty(registerUrl)) {
		return (
			<InlineShareButtons
				config={{
					alignment: "center",
					color: "social",
					enabled: true,
					language: "en",
					networks: ["telegram", "whatsapp", "facebook", "twitter"],
					padding: 12,
					radius: 35,
					size: 30,

					url: registerUrl,
				}}
			/>
		);
	} else {
		return null;
	}
}, [registerUrl]);

function copyUrl() {
	navigator.clipboard.writeText(registerUrl);
	setShowCodeAlert(true);
	setTimeout(() => setShowCodeAlert(false), [_ALERT_TIMEOUT]);
}


function copyItem(item) {
	navigator.clipboard.writeText(item);
	setShowCodeAlert(true);
	setTimeout(() => setShowCodeAlert(false), [_ALERT_TIMEOUT]);
}

  function onVerifyPinKeyPress(key) {
    let currentIndex = 0;
    let pinStr = enteredPinNumberFinal;
    if (key !== "{bksp}" && key !== "&nbsp;") {
      if (pinNumberFinal === "") {
        currentIndex = pinNumberFinalFocused;
        eleFinalPin["current"]["elements"][currentIndex].state.value = key;
        pinStr += key;
        setEnteredPinNumberFinal(pinStr);
        if (currentIndex !== 3) {
          currentIndex++;
          setPinNumberFinalFocused(currentIndex);
          eleFinalPin["current"]["elements"][currentIndex].focus();
        } else {
          verifyPin(pinStr);
        }
      }
    } else {
      eleFinalPin["current"].clear();
      setPinNumberFinal("");
      setEnteredPinNumberFinal("");
      setPinNumberFinalFocused(currentIndex);
      eleFinalPin["current"]["elements"][currentIndex].focus();
    }
  }

  async function isAnyUnreadNotification() {
    let responseJson = await ApiEngine.get(
      ApiUrl._API_CHECK_ANY_UNREAD_NOTIFICATION +
      "?LanguageId=" +
      memberData["languageSetting"]
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setUnreadNotification(responseJson[ApiKey._API_DATA_KEY]);
    }
  }

  /// <summary>
  /// Author:
  /// </summary>
  useEffect(() => {
    if (countdownPeriod > 0) {
      setTimeout(() => {
        let tempPeriod = countdownPeriod - 1;
        setCountdownPeriod(tempPeriod);
      }, _SECONDS_IN_MS);
    }
  }, [countdownPeriod]);

  async function RefreshBalanceF(masterProductId) {
    setMasterProductId(masterProductId);
    _dispatch(setBusy());
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE +
      "?masterProductId=" +
      masterProductId
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let tempFromOptions = [];
      let tempToOptions = [];

      responseJson[ApiKey._API_DATA_KEY].map((product) => {
        let option = {
          label: product.productName,
          value: product.productId,
          amount: parseFloat(product.balance),
        };
        if (product.productId === _MAIN_WALLET_ID) {
          tempFromOptions.push(option);
        } else if (product.productId === masterProductId) {
          setBonus(product.bonus);
          tempToOptions.push(option);
        }
      });
      setFromOptions(tempFromOptions);
      setToOptions(tempToOptions);
      _dispatch(setIdle());
      setDisabled(true);
      setTimeout(() => setDisabled(false), 5000);
    }
  }

  async function sendPinCode() {
    if (countdownPeriod < 1) {
      let responseJson = await ApiEngine.get(
        ApiUrl._API_CHECK_IF_PHONE_VERIFIED
      );
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        var hpNum = responseJson[ApiKey._API_DATA_KEY];
        let params = {
          phoneNumber: hpNum,
          isShareholder: "true",
        };
        let smsJson = await ApiEngine.post(
          ApiUrl._API_SEND_PIN_CODE,
          createFormBody(params)
        );
        if (smsJson[ApiKey._API_SUCCESS_KEY]) {
          setSmsSent(true);
          setCountdownPeriod(_COUNTDOWN_PERIOD);
        }
      } else {
        _dispatch(
          showResponseMessage(
            responseJson[ApiKey._API_SUCCESS_KEY],
            responseJson[ApiKey._API_MESSAGE_KEY]
          )
        );
      }
    } else {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), [_ALERT_TIMEOUT]);
    }
  }

  async function updateWalletBalance() {
    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let tempFromOptions = [];
      let tempToOptions = [];
      responseJson[ApiKey._API_DATA_KEY].map((product) => {
        let option = {
          label: product.productName,
          value: product.productId,
          amount: parseFloat(product.balance),
        };
        if (product.productId === _MAIN_WALLET_ID) {
          tempFromOptions.push(option);
        } else if (product.productId === masterProductId) {
          tempToOptions.push(option);
        }
      });
      setFromOptions(tempFromOptions);
      setToOptions(tempToOptions);
    }
  }

  async function startGame(
    gameId,
    hasOwnLobby,
    masterProductId,
    gameName,
    isSeamless,
    isApp,
    appUrl,
    appDeepLink,
    isNewWindow,
    packageNameKeyword,
    categoryTitle

  ) {
    setSelectedGameName(gameName);
    setMasterProductId(masterProductId);
    setIsApp(isApp);
    setAppDeepLink(appDeepLink);
    setSelectedGameHasOwnLobby(hasOwnLobby);
    setSelectedGameIsSeamless(isSeamless);
    if (isApp && !stringIsNullOrEmpty(appUrl)) {
      setAppUrl(appUrl);
    }
    if (hasOwnLobby !== true) {
      if (isSeamless == false) {
        _dispatch(setBusy());
        var responseJson = await ApiEngine.get(
          ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE +
          "?masterProductId=" +
          masterProductId
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
          let tempFromOptions = [];
          let tempToOptions = [];

          responseJson[ApiKey._API_DATA_KEY].map((product) => {
            let option = {
              label: product.productName,
              value: product.productId,
              amount: parseFloat(product.balance),
            };
            if (product.productId === _MAIN_WALLET_ID) {
              tempFromOptions.push(option);
            } else if (product.productId === masterProductId) {
              setBonus(product.bonus);
              tempToOptions.push(option);
            }
          });
          setFromOptions(tempFromOptions);
          setToOptions(tempToOptions);

          var mpJson = await ApiEngine(
            ApiUrl._API_GET_MEMBER_PRODUCT_DETAILS +
            "?masterProductId=" +
            masterProductId
          );
          if (mpJson[ApiKey._API_SUCCESS_KEY]) {
            let data = mpJson[ApiKey._API_DATA_KEY];
            setMpData(data);
            if (window.ReactNativeWebView && isApp) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  action: "deeplink",
                  url: appUrl,
                  deeplink: appDeepLink
                    .replace("[username]", data["username"])
                    .replace("[password]", data["password"]),
                  packageKeyword: packageNameKeyword,
                })
              );
            }
            setAppUsername(data["username"]);
            setAppPassword(data["password"]);
          }
        }

        if (
          gameName == "Pussy888" ||
          gameName == "Mega888" ||
          gameName == "Evo888" ||
          gameName == "918Kiss"
        ) {
          setShowAppCred(true);
        }

        setProductGameId(gameId);
        var isNewWindowJson = await ApiEngine(
          ApiUrl._API_GET_GAME_IS_NEW_WINDOW + "?gameId=" + gameId
        );
        setIsNewWindow(isNewWindowJson[ApiKey._API_DATA_KEY]);
        setShowPregamePopup(true);
        getProductComRate(gameName);
        getVipCriteria(categoryTitle);
        getRolloverProgress(masterProductId);
        getPromotion(masterProductId)
        _dispatch(setIdle());
      } else {
        window.open(
          ApiUrl._API_START +
          "?gameId=" +
          gameId +
          "&isApp=" +
          (isApp ? 1 : 0) +
          "&device=" +
          (window.innerWidth <= 768 ? "m" : "d")
        );
      }
    } else {
      if (isSeamless == false) {
        _dispatch(setBusy());
        var responseJson = await ApiEngine.get(
          ApiUrl._API_GET_NON_SEAMLESS_PRODUCT_BALANCE +
          "?masterProductId=" +
          masterProductId
        );
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
          let tempFromOptions = [];
          let tempToOptions = [];

          responseJson[ApiKey._API_DATA_KEY].map((product) => {
            let option = {
              label: product.productName,
              value: product.productId,
              amount: parseFloat(product.balance),
            };
            if (product.productId === _MAIN_WALLET_ID) {
              tempFromOptions.push(option);
            } else if (product.productId === masterProductId) {
              setBonus(product.bonus);
              tempToOptions.push(option);
            }
          });
          setFromOptions(tempFromOptions);
          setToOptions(tempToOptions);

          var mpJson = await ApiEngine(
            ApiUrl._API_GET_MEMBER_PRODUCT_DETAILS +
            "?masterProductId=" +
            masterProductId
          );
          if (mpJson[ApiKey._API_SUCCESS_KEY]) {
            let data = mpJson[ApiKey._API_DATA_KEY];
            setMpData(data);
          }
        }

        var isNewWindowJson = await ApiEngine(
          ApiUrl._API_GET_GAME_IS_NEW_WINDOW + "?gameId=" + gameId
        );
        setIsNewWindow(isNewWindowJson[ApiKey._API_DATA_KEY]);
        setShowPregamePopup(true);
        getProductComRate(gameName);
        getVipCriteria(categoryTitle);
        setProductGameId(gameId);
        SetToLobbyBtn(true);
        getRolloverProgress(masterProductId);

        _history.push(
          WebUrl._URL_GAME_LOBBY +
          "?name=" +
          gameName +
          "&id=" +
          gameId +
          "&languageId=" +
          memberData["languageSetting"]
        );
        _dispatch(setIdle());
      }
    }
  }

  function copyText(textType) {
    if (textType === "username") {
      usernameRef.current.select();
    } else if (textType === "password") {
      passwordRef.current.select();
    }
    document.execCommand("copy");
  }

  const submitPopupForm = async (data, e) => {
    _dispatch(setBusy());

    let params = {
      fromWallet: _MAIN_WALLET_ID,
      toWallet: masterProductId,
      amount: toGameAmount,
      depositPromotionProductId: promoId,
    };

    let responseJson = await ApiEngine.post(
      ApiUrl._API_CREATE_WALLET_TRANSFER_TRANSACTION,
      createFormBody(params)
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      await updateWalletBalance(
        parseFloat(responseJson[ApiKey._API_DATA_KEY].amount).toFixed(2)
      );
      setIsTransferSuccess(true);
      setTransferShow(false);
      getRolloverProgress(masterProductId);
      RefreshBalanceF(masterProductId);
      e.target.reset();
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
    }
    _dispatch(setIdle());
  };

  const homeMenu = [
    {
      icon: themeIcons.dashboardBalanceDeposit,
      text: "DEPOSIT",
      url: WebUrl._URL_DEPOSIT,
    },
    {
      icon: themeIcons.dashboardBalanceWithdraw,
      text: "WITHDRAW",
      url: WebUrl._URL_WITHDRAWAL_METHODS,
    },
    {
      icon: themeIcons.dashboardBalanceRestore,
      text: "REFRESH",
      url: "",
    },
    {
      icon: themeIcons.qrcode,
      text: "QR_CODE",
      url: "",
    }
  ];

  const homeMenu2 = [
    {
      icon: themeIcons.dashboardCommissionClaim,
      text: "CLAIM",
      url: WebUrl._URL_COMMISSION,
    },
    {
      icon: themeIcons.dashboardCommissionDownlines,
      text: "DOWNLINE",
      url: WebUrl._URL_MY_DOWNLINES,
    },
    {
      icon: themeIcons.dashboardCommissionReferral,
      text: "REFERRAL",
      url: WebUrl._URL_REFERRAL_GROUPS,
    },
    {
      icon: themeIcons.dashboardCommissionSales,
      text: "KPI",
      url: WebUrl._URL_KPI,
    },
  ];

  const homeMenu3 = [
    {
      icon: themeIcons.dashboardPointsCheckin,
      text: "CHECK_IN",
      url: WebUrl._URL_DAILY_CHECK_IN,
    },
    {
      icon: themeIcons.dashboardPointsShop,
      text: "SHOP",
      url: WebUrl._URL_DC_REDEMPTION,
    },
    {
      icon: themeIcons.dashboardPointsHistory,
      text: "HISTORY",
      url: WebUrl._URL_DC_POINTS_HISTORY,
    },
    {
      icon: themeIcons.dashboardPointsRecord,
      text: "RECORD",
      url: WebUrl._URL_DC_REDEMPTION_HISTORY,
    },
  ];


  async function getRolloverProgress(masterProductId) {
    setRolloverBalance("");
    setRolloverTarget("");
    if (masterProductId != "0") {
      var responseJson = await ApiEngine.get(
        ApiUrl._API_GET_DEPOSIT_PROMOTION_ROLLOVER_PROGRESS +
        "?masterProductId=" +
        masterProductId
      );
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        if (responseJson[ApiKey._API_DATA_KEY] != null) {
          if (responseJson[ApiKey._API_DATA_KEY].data != null) {
            setRolloverBalance(
              responseJson[ApiKey._API_DATA_KEY].data["rolloverBalance"]
            );
            setRolloverTarget(
              responseJson[ApiKey._API_DATA_KEY].data["rolloverTarget"]
            );
            setBonusTarget(
              responseJson[ApiKey._API_DATA_KEY].data["bonusTarget"]
            );
            setMaxWithdraw(
              responseJson[ApiKey._API_DATA_KEY].data["maxWithdraw"]
            );
          }
        }
      }
    }
  }

  const bannerSlick = {
    slidesToShow: 1,
    dots: true,
    arrows: false,
    swipe: true,
    infinite: true,
    swipeToSlide: true,
    speed: 1000,
    autoplay: true,
    beforeChange: () => setDragging(true),
    afterChange: () => setDragging(false),
  };

  const tempUpdateUserData = async () => {
    if (isLoggedIn) {

      let walletResponse = await ApiEngine.get(
        ApiUrl._API_GET_MEMBER_WALLET_BALANCE
      );
      if (walletResponse[ApiKey._API_SUCCESS_KEY]) {
        var totalwalletbalance = walletResponse[ApiKey._API_DATA_KEY].primaryCredit + walletResponse[ApiKey._API_DATA_KEY].tempPrimaryCredit;
        var totalbonuswallet = walletResponse[ApiKey._API_DATA_KEY].bonusWallet + walletResponse[ApiKey._API_DATA_KEY].tempBonusWallet;

        setTempMainWallet(walletResponse[ApiKey._API_DATA_KEY].tempPrimaryCredit);
        setTempBonusWallet(walletResponse[ApiKey._API_DATA_KEY].tempBonusWallet);
        setCurrentWalletBalance(totalwalletbalance);
        setBonusWalletBalance(totalbonuswallet);
        setIsPromoCleared(walletResponse[ApiKey._API_DATA_KEY].isPromoCleared)
        setIsBonusWalletRestored(walletResponse[ApiKey._API_DATA_KEY].isBonusWalletRestored)
        setIsValidForPromotion(walletResponse[ApiKey._API_DATA_KEY].isAnyTransactionValidForPromo)
        setIsActivePromoExist(walletResponse[ApiKey._API_DATA_KEY].isActivedPromoExist)
        setMaxWithdraw(walletResponse[ApiKey._API_DATA_KEY].bonusMaxWithdraw)
        setIsInitLoaded(true);
      }
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      //disable auto update memberWallet and bonus wallet
      setInterval(() => tempUpdateUserData(), 30000);
      tempUpdateUserData();
    }
  }, [isLoggedIn]);


  async function getProductComRate(selectedGameName) {
    let apiUrl = ApiUrl._API_PRODUCT_COMM_RATE;
    let data = [];
    let responseJson = await ApiEngine.get(apiUrl);
    if (
      responseJson[ApiKey._API_SUCCESS_KEY] &&
      responseJson[ApiKey._API_DATA_KEY].length > 0
    ) {
      data = responseJson[ApiKey._API_DATA_KEY].filter(
        (x) => x.productName === selectedGameName
      );

      if (data.length > 0) {
        setProductCommRate(data[0]);
      }
    }
  }



  async function checkDC() {

    let data = [];
    const dailyArr = [];

    let responseJson = await ApiEngine.get(
      ApiUrl._API_GET_DAILY_CHECK_IN_RECORD
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      data = responseJson[ApiKey._API_DATA_KEY]["dataPoints"];

      const dailyRate = data["details"];
      const dailyRecord = responseJson[ApiKey._API_DATA_KEY]["latestRecord"];

      dailyRate.map((x) => {
        dailyArr.push({
          id: x.id,
          dcid: x.dcid,
          label: x.days,
          points: x.points,
          isBigPrize: x.isBigPrize,
        });
      });

      setDCRate(dailyArr);

      if (responseJson[ApiKey._API_DATA_KEY]["isYesterdayCheckIn"]) {
        if (!responseJson[ApiKey._API_DATA_KEY]["isTodayCheckIn"]) {
          if (!stringIsNullOrEmpty(dailyRecord)) {
            setActiveIndex(dailyRecord?.[0]["index"] + 1);
          }
          setClaimed(false);
        } else {
          if (!stringIsNullOrEmpty(dailyRecord)) {
            setActiveIndex(dailyRecord?.[0]["index"]);
          }
          setClaimed(true);
        }
      } else {
        if (!responseJson[ApiKey._API_DATA_KEY]["isTodayCheckIn"]) {
          setActiveIndex(1);
          setClaimed(false);
        } else {
          if (!stringIsNullOrEmpty(dailyRecord)) {
            setActiveIndex(dailyRecord?.[0]["index"]);
          }

          setClaimed(true);
        }
      }
    }
  }

  async function handleSubmitDC(item) {
    let params = {
      DCID: item.dcid,
      DCDID: item.id,
      points: item.points,
    };

    let responseJson = await ApiEngine.post(
      ApiUrl._API_CREATE_MEMBER_DAILY_CHECK_IN,
      createFormBody(params)
    );
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          t("YOU_VE_SUCCESSFULLY_CHECKIN_PLEASE_COME_AGAIN_TOMMORROW", {
            value: item.points,
          })
        )
      );
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          t(responseJson[ApiKey._API_MESSAGE_KEY])
        )
      );
    }

    checkDC();
  }

  function CountDownTimer() {
    const cambodiaTimeZone = "Asia/Phnom_Penh";

    // Create a Date object for the current time in Cambodia time (ICT)
    const currentCambodiaTime = new Date().toLocaleString("en-US", {
      timeZone: cambodiaTimeZone,
    });

    // Parse the current Cambodia time into a Date object
    const currentTime = new Date(currentCambodiaTime);

    // Create a Date object for 23:59:59 in Cambodia time (ICT)
    const endTime = new Date(currentTime);
    endTime.setHours(23, 59, 59, 0); // Set to 23:59:59

    var timer;
    function showRemaining() {
      // Calculate the time difference
      const timeDifference = endTime - currentTime;

      if (timeDifference < 0) {
        clearInterval(timer);
        return;
      }

      // Calculate hours and minutes remaining
      const hoursRemaining = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutesRemaining = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );

      if (hoursRemaining < 8)
        setCountdownText(hoursRemaining + "h " + minutesRemaining + "m");
    }

    timer = setInterval(showRemaining, 1000);
  }

  async function redirectHistory() {
    _history.push(WebUrl._URL_DC_POINTS_HISTORY);
  }

  async function openQRModal() {
    /*await getCodeDetail();*/
    if (memberData["referralCode"] == null) {
      _history.push(WebUrl._URL_REFERRAL_GROUPS);
    } else {
      setRegisterUrl(
        window.location.origin +
        _APPEND_REGISTER_URL +
        memberData["referralCode"]
      );
      //await getUpline(memberData["referralCode"]);
      setQRModal(true);
    }
  }


  const onChangeLanguage = async (selectedLanguage) => {
    i18n.changeLanguage(selectedLanguage);

    // console.log(LanguageOption)
    localStorage.setItem(SessionKey._LANGUAGE, selectedLanguage);
    _cookies.set(SessionKey._LANGUAGE, selectedLanguage);
    if (isLoggedIn) {
      _dispatch(saveLanguageId(selectedLanguage, true));
      // // changeLanguage(selectedLanguage)

      let data = {};
      data["languageSetting"] = selectedLanguage;

      await ApiEngine.post(
        ApiUrl._API_UPDATE_MEMBER_LANGUAGE,
        createMultiPartFormBody(data)
      );

    }
  }

  const getSliderBanner = () => {
    let { code: langCode } = _.find(LanguageOption, {
      code: localStorage.getItem(SessionKey._LANGUAGE) ?? Language._KHMER,
    });

    ApiEngine.get(
      ApiUrl._API_GET_USER_BANNER +
      "?page=" +
      window.location.pathname +
      "&languagecode=" +
      langCode
    ).then((responseJson) => {
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        setBanners(responseJson[ApiKey._API_DATA_KEY]);
      }
    });
  }
  const toggleLanguageDropDown = () => setDropdownLanguageOpen((prevState) => !prevState);

  const onClickLanguage = (value) => {
    let findLanguage = _.find(LanguageOption, { value: value });

    setLanguageSelected(findLanguage);
    onChangeLanguage(value);
    getSliderBanner()
    getMarqueeTagContent(findLanguage.languageId);


  };

  const getPromotion = async (id, languageId) => {
    let apiUrl = `${ApiUrl._API_GET_RELATED_DEPOSIT_PROMOTION_BY_PRODUCT_ID}`;
    if (
      localStorage.getItem(SessionKey._LANGUAGE) &&
      localStorage.getItem(SessionKey._LANGUAGE) != "undefined"
    ) {
      if (
        LanguageOption.find(
          (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)
        ) != undefined
      ) {
        apiUrl +=
          "?langId=" +
          LanguageOption.find(
            (x) => x.code === localStorage.getItem(SessionKey._LANGUAGE)
          ).languageId
      } else {
        apiUrl += "?langId=1";
      }
    } else {
      apiUrl += "?langId=1";
    }

    apiUrl += "&productId=" + id;

    let responseJson = await ApiEngine.get(apiUrl);

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      setPromotionList(responseJson[ApiKey._API_DATA_KEY]);
    }
  };

  async function claimPromotion(promoId) {
    _dispatch(setBusy());
    let params = {
      promoId: promoId,
    };
    let formBody = createMultiPartFormBody(params);
    let responseJson = await ApiEngine.post(
      ApiUrl._API_CLAIM_PROMOTION_FS,
      formBody
    );
    _dispatch(setIdle());
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
      init(props.id, props.languageId);
      getPromotion(masterProductId)
    } else {
      _dispatch(
        showResponseMessage(
          responseJson[ApiKey._API_SUCCESS_KEY],
          responseJson[ApiKey._API_MESSAGE_KEY]
        )
      );
      init(props.id, props.languageId);
    }
    getRolloverProgress(masterProductId)
    setShowPromo(false);
  }

  async function setTransactionValidForPromo() {
    _dispatch(setBusy());
    let responseJson = await ApiEngine.get(ApiUrl._API_UPDATE_TRANSACTION_VALID_FOR_PROMO);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      getPromotion(masterProductId)
      setIsValidForPromotion(false)
    }
    _dispatch(setIdle());
    setSelectedGame([]);

  }

  //used for fake seamless
  async function startGame2(gameId, gameName, isSeamless, isNewWindow) {
    if (!window.ReactNativeWebView) {
      window.open(
        `${process.env.REACT_APP_ENDPOINT_URL || ""}${ApiUrl._API_START
        }?gameId=${gameId}&isApp=0&device=${window.innerWidth <= 768 ? "m" : "d"
        }`
      );
    } else {
      if (isApp) {
        let responseJson = await ApiEngine.get(
          ApiUrl._API_START + "?gameId=" + gameId + "&isApp=1&device=m"
        );
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            action: "deeplink",
            url: appUrl,
            deeplink: appDeepLink
              .replace("[username]", mpData["username"])
              .replace("[password]", mpData["password"]),
          })
        );
      } else {
        if (isNewWindow === true) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              url: `${process.env.REACT_APP_ENDPOINT_URL || window.location.origin
                }${ApiUrl._API_START}?gameId=${gameId}&device=${window.innerWidth <= 768 ? "m" : "d"
                }`,
            })
          );
        } else {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              url: `${process.env.REACT_APP_ENDPOINT_URL || window.location.origin
                }${WebUrl._URL_GAME_PAGE}?gameId=${gameId}`,
            })
          );
        }
      }

    }
  }

  async function getVipCriteria(selectedGame) {
    if (selectedGame == 'Slots') {
      selectedGame = 'Slot'
    }
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_ALL_VIP_COMMISSION);

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      let res = [];
      for (let obj of data) {
        for (let key of Object.keys(obj)) {

          if (key.includes(selectedGame)) {
            let title = ''
            if (obj['content'].includes('Normal')) {
              title = 'NORMAL'
            } else if (obj['content'].includes('Bronze')) {
              title = 'BRONZE'
            } else if (obj['content'].includes('Silver')) {
              title = 'SILVER'
            } else if (obj['content'].includes('Gold')) {
              title = 'GOLD'
            } else if (obj['content'].includes('Platinum')) {
              title = 'PLATINUM'
            } else if (obj['content'].includes('Diamond')) {
              title = 'DIAMOND'
            }
            res.push({ vipId: obj['vipId'], content: title, value: obj[key] });
          }
        }
      }
      setCommissionInfo(res)

    }
  }

  useEffect(() => {
    // If seconds reach zero, stop the timer
    if (seconds === 0) return;

    // Set up an interval that decreases the seconds by 1 every second
    const interval = setInterval(() => {
      if (rolloverTarget > 0) {
        getRolloverProgress(masterProductId)
      }
      setSeconds(prevSeconds => prevSeconds - 1);
    }, 15000);

    // Clear the interval on component unmount
    return () => clearInterval(interval);
  }, [seconds]);

  const getRecentPayout = async () => {
    var responseJsonPayout = await ApiEngine.get(
      ApiUrl._API_GET_RECENT_PAYOUT
    );

    if (responseJsonPayout[ApiKey._API_SUCCESS_KEY]) {
      setPayoutList(responseJsonPayout[ApiKey._API_DATA_KEY])
    }
  }  

  const getTopDepositWithdrawal = async () => {
    _dispatch(setBusy());

    var responseJson = await ApiEngine.get(
      ApiUrl._API_GET_TOP_DEPOSIT_WITHDRAWAL
    );

    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      const latestDepositData = _.filter(responseJson[ApiKey._API_DATA_KEY], {
        transactionTypeId: 1,
      });
      const latestWithdrawalData = _.filter(responseJson[ApiKey._API_DATA_KEY], {
        transactionTypeId: 2,
      });

      setLatestDepositList(latestDepositData);
      setLatestWithdrawalList(latestWithdrawalData);
    } else {
      throw responseJson[ApiKey._API_MESSAGE_KEY];
    }
    _dispatch(setIdle());


  }

  return (
    <>
      <div className="all-section-box cover-90" id="main-homepage">
        <div className="d-flex align-items-center justify-content-between pt-1 mb-1">
          <div style={{ width: 55 }}></div>
          <div>
            {memberData.length == 0 ? (
              <img
                src={
                  require("../../../assets/img/logobig2.png")
                }
                className="img-responsive"
                style={{ height: "35px" }}
                alt="logo"
              />
            ) : (
              <img
                src={
                  !stringIsNullOrEmpty(memberData["logo"])
                    ? memberData?.["logo"]
                    : require("../../../assets/img/logobig2.png")
                }
                className="img-responsive"
                style={{ height: "35px" }}
                alt="logo"
              />
            )}
          </div>

          <div className="d-flex">
            <div
              className="dashboard-noti"
              onClick={() => _history.push(WebUrl._URL_NEWS)}
              style={{ cursor: "pointer" }}
            >
              {unreadNotification ? (
                <div className="header-notif-box">
                  <VIcon
                    icon={themeIcons.dashboardNotification}
                    className="theme-icon-size-20"
                  />
                  <div className="notif-red"></div>
                </div>
              ) : (
                <div className="header-notif-box">
                  <VIcon
                    icon={themeIcons.dashboardNotification}
                    className="theme-icon-size-20"
                  />
                </div>
              )}
            </div>

            <Dropdown
              className="language-dropdown"
              isOpen={dropdownLanguageOpen}
              toggle={toggleLanguageDropDown}
              direction={"down"}
              end={true}
            >
              <DropdownToggle>
                <img src={`/images/${languageSelected.code}.png`} alt={languageSelected.code} width="20" height="20"/>
              </DropdownToggle>
              <DropdownMenu>
                {map(LanguageOption, (item, index) => {
                  return (
                    <DropdownItem onClick={() => onClickLanguage(item.value)}>
                      <img src={`/images/${item.code}.png`} alt={item.code} width="20" height="20"/> <span className="ml-1">{item.name}</span>
                    </DropdownItem>
                  );
                })}

              </DropdownMenu>
            </Dropdown>
          </div>

        </div>
        {showConfirmation && (
          <SweetAlert
            showCancel
            confirmBtnText={t("YES")}
            cancelBtnText={t("NO")}
            confirmBtnBsStyle="info"
            icon
            onConfirm={() => {
              setShowConfirmation(false);
              getRestore();
            }}
            onCancel={() => {
              setShowConfirmation(false);
            }}
            custom
            style={{
              backgroundColor: "#05102F",
              opacity: 0.9,
              marginTop: "68%",
            }}
            cancelBtnBsStyle="#05102F"
            customIcon={require("../../../assets/img/home/new/info-icon.png")}
          >
            <span className="sweet-alert-custom-text">
              {t("RESTORE_WALLETS")}
            </span>
          </SweetAlert>
        )}
        {showEndPromoConfirmation && (
          <SweetAlert
            showCancel
            confirmBtnText={t("YES")}
            cancelBtnText={t("NO")}
            confirmBtnBsStyle="info"
            icon
            onConfirm={() => {
              setShowEndPromoConfirmation(false);
              getRestoreAccountBlance();
            }}
            onCancel={() => {
              setShowEndPromoConfirmation(false);
            }}
            custom
            style={{
              backgroundColor: "#05102F",
              opacity: 0.9,
              marginTop: "68%",
            }}
            cancelBtnBsStyle="#05102F"
            customIcon={require("../../../assets/img/home/new/info-icon.png")}
          >
            <span className="sweet-alert-custom-text">
              {t("CANCEL_PROMO_INFO")}
            </span>
          </SweetAlert>
        )}
        {showPromotionConfirmation && (
          <SweetAlert
            showCancel
            confirmBtnText={t("CONTINUE")}
            cancelBtnText={t("CANCEL")}
            confirmBtnBsStyle="info"
            icon
            onConfirm={() => {
              setShowPromotionConfirmation(false);
              setTransactionValidForPromo();
              startGame2(productGameId, selectedGameName, selectedGameIsSeamless, isNewWindow)
            }}
            onCancel={() => {
              setShowPromotionConfirmation(false);
              _history.push(WebUrl._URL_FS_PROMOTION);
            }}
            custom
            style={{
              backgroundColor: "#05102F",
              opacity: 0.9,
              marginTop: "68%",
            }}
            cancelBtnBsStyle="#05102F"
            customIcon={require("../../../assets/img/home/new/info-icon.png")}
          >
            <span className="sweet-alert-custom-text">
              {t("PLEASE_CLAIM_PROMO_BEFORE_ENTER_GAME")}
            </span>
          </SweetAlert>
        )}

        {showRestoreAccBlanceConfirmation && (
          <SweetAlert
            showCancel
            confirmBtnText={t("YES")}
            cancelBtnText={t("NO")}
            confirmBtnBsStyle="info"
            icon
            onConfirm={() => {
              setShowRestoreAccBlanceConfirmation(false);
              getRestoreAccountBlance();
            }}
            onCancel={() => {
              setShowRestoreAccBlanceConfirmation(false);
            }}
            custom
            style={{
              backgroundColor: "#05102F",
              opacity: 0.9,
              marginTop: "68%",
            }}
            cancelBtnBsStyle="#05102F"
            customIcon={require("../../../assets/img/home/new/info-icon.png")}
          >
            <span className="sweet-alert-custom-text">
              {t("CONVERT_BONUS_TO_MAIN_WALLET").replace("{0}", numberWithCurrencyFormat(parseFloat((maxWithdraw == 0 ? bonusWalletBalance : maxWithdraw)), 2, true)).toString()}
            </span>
          </SweetAlert>
        )}

        <div className="home-announcement">
          <div className="home-announcement-icon1">
            <VIcon
              icon={themeIcons.dashboardAnnouncement}
              className="theme-icon-size-20"
            />
          </div>
          <marquee className="marquee-container">
            <span className="text">
              {!stringIsNullOrEmpty(content) && parse(content)}
            </span>
          </marquee>
        </div>

        <Slider {...bannerSlick} className="home-banner-slick">
          {banners &&
            banners.length &&
            map(banners, (item, index) => {
              return (
                <div
                  key={index}
                >
                    <div
                        className="banner-items"
                        style={{   
                            backgroundImage: `url(${item.mobileImage})`
                        }}
                        onClick={(e) => {
                            if (dragging) {
                            e.preventDefault()
                            } else {
                            window.location.href = `${process.env.REACT_APP_ENDPOINT_URL || ""
                                }${item.url}`;
                            }

                        }}
                    >
                    </div>
                </div>
              );
            })}
        </Slider>
        {
          !isLoggedIn ? (
            <div className="authenticate-container" style={{ fontWeight: "bold", backgroundColor: "transparent" }}>
              <Link to={{ pathname: WebUrl._URL_LOGIN }}>{t('LOGIN')}</Link>
              <Link className="register" to={{ pathname: WebUrl._URL_MLMREGISTER }}>{t('REGISTER')}</Link>
            </div>) : ""
        }

        
        {
          isLoggedIn ? (
            <div className="home-balance-commission-container mt-1 mb-1">
              <div className="home-balance-container-tabs">
                <div
                  className={
                    balanceAndCommissionActive == 1
                      ? "home-balance-container-tab-header active"
                      : "home-balance-container-tab-header"
                  }
                  onClick={() => setBalanceAndCommissionActive(1)}
                  style={{ cursor: "pointer" }}
                >
                  <div>{t("BALANCE")}</div>
                </div>
                <div
                  className={
                    balanceAndCommissionActive == 2
                      ? "home-balance-container-tab-header active"
                      : "home-balance-container-tab-header"
                  }
                  onClick={() => setBalanceAndCommissionActive(2)}
                  style={{ cursor: "pointer" }}
                >
                  <div>{t("COMMISSION")}</div>
                </div>
                <div
                  className={
                    balanceAndCommissionActive == 3
                      ? "home-balance-container-tab-header active"
                      : "home-balance-container-tab-header"
                  }
                  onClick={() => setBalanceAndCommissionActive(3)}
                  style={{ cursor: "pointer" }}
                >
                  <div>{t("POINTS")}</div>
                </div>
                <div
                  className="home-balance-eye"
                  onClick={() =>
                    setHideBalanceAndCommission(!hideBalanceAndCommission)
                  }
                  style={{ cursor: "pointer" }}
                >
                  {hideBalanceAndCommission ?
                    <VIcon
                      icon={themeIcons.eyeblocked}
                      className="theme-icon-size-20"
                    />
                    :
                    <VIcon
                      icon={themeIcons.eye}
                      className="theme-icon-size-20"
                    />
                  }
                </div>
              </div>
              <div className="home-balance-container-tabs-items">
                {balanceAndCommissionActive == 1 && (
                  <>
                    <div className="home-balance-com-box">
                      <div className="hbc-box ">
                        <div className="first">
                          <div className="hbc-label font12 text-lgray4">
                            {t("MAIN_WALLET")}
                          </div>
                          <div className="hbc-balance font14 f-weight-500">
                            {hideBalanceAndCommission
                              ? numberWithCurrencyFormat(
                                currentWalletBalance,
                                2,
                                true
                              ).replace(/./g, "*")
                              : numberWithCurrencyFormat(
                                currentWalletBalance,
                                2,
                                true
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="hbc-box ">
                        <div className="first">
                          <div
                            className="hbc-label font12 text-lgray4"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {t("BONUS_WALLET")}
                          </div>
                          <div className="hbc-balance font14 f-weight-500">
                            {hideBalanceAndCommission
                              ? numberWithCurrencyFormat(
                                bonusWalletBalance,
                                2,
                                true
                              ).replace(/./g, "*")
                              : numberWithCurrencyFormat(
                                bonusWalletBalance,
                                2,
                                true
                              )}
                          </div>
                        </div>
                        {((isPromoCleared && !isBonusWalletRestored) 
                            || (isActivedPromoExist && bonusWalletBalance == 0) 
                            || (!isPromoCleared && !isBonusWalletRestored && bonusWalletBalance <= 0.2 && isActivedPromoExist)
                        ) 
                        && bonusWalletBalance > maxWithdraw &&
                          <div className="second-wrapper" onClick={() => {
                            setShowRestoreAccBlanceConfirmation(true);
                          }}
                          >
                            <div className="second">
                              <div className={`active-tag active`}>{ t("END")}</div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>

                    <div className="home-balance-commission-buttons mt-2">
                      {homeMenu &&
                        homeMenu.length &&
                        map(homeMenu, (item, index) => {
                          return (
                            <div
                              key={index}
                              className="home-bc-item"
                              onClick={() => {
                                item.text == "REFRESH"
                                  ? setShowConfirmation(true)
                                  : (item.text == "QR_CODE" ? openQRModal() : _history.push(item.url));
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className={`home-bc-item-wrapper ${item.text == "QR_CODE" ? "home-bc-item-wrapper-golden" : ""}`}>
                                <div className="first">
                                  <VIcon
                                    icon={item.icon}
                                    className="theme-icon-blue-size-20"
                                  />
                                </div>
                                <div className="second">{t(item.text)}</div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
                {balanceAndCommissionActive == 2 && (
                  <>
                    <div className="home-balance-container">
                      <div className="home-balance-top-box">
                        <div className="first">
                          <div
                            className="first"
                            onClick={() => _history.push(WebUrl._URL_COMMISSION)}
                            style={{ cursor: "pointer" }}
                          >
                            <VIcon
                              icon={themeIcons.dashboardCommission}
                              className="theme-icon-blue-size-20"
                            />
                          </div>
                          <div className="second">
                            <div className="home-balance-input">
                              {hideBalanceAndCommission
                                ? numberWithCurrencyFormat(
                                  unclaimComm.totalClaimable,
                                  2,
                                  true
                                ).replace(/./g, "*")
                                : numberWithCurrencyFormat(
                                  unclaimComm.totalClaimable,
                                  2,
                                  true
                                )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="second"
                          onClick={() => getCommissionData()}
                          style={{ cursor: "pointer" }}
                        >
                          <VIcon
                            icon={themeIcons.refresh}
                            className="theme-icon-size-15"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="home-balance-commission-buttons mt-2">
                      {homeMenu2 &&
                        homeMenu2.length &&
                        map(homeMenu2, (item, index) => {
                          return (
                            <div
                              key={index}
                              className="home-bc-item"
                              onClick={() => _history.push(item.url)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="home-bc-item-wrapper">
                                <div className="first">
                                  <VIcon
                                    icon={item.icon}
                                    className="theme-icon-blue-size-20"
                                  />
                                </div>
                                <div className="second">{t(item.text)}</div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
                {balanceAndCommissionActive == 3 && (
                  <>
                    <div className="home-balance-container">
                      <div className="home-balance-top-box">
                        <div className="first">
                          <div
                            className="first"
                            onClick={() =>
                              _history.push(WebUrl._URL_DAILY_CHECK_IN)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <VIcon
                              icon={themeIcons.dashboardPoints}
                              className="theme-icon-blue-size-20"
                            />
                          </div>
                          <div className="second">
                            <div className="home-balance-input">
                              {hideBalanceAndCommission
                                ? numberWithCurrencyFormat(
                                  unclaimPoints,
                                  2,
                                  true
                                ).replace(/./g, "*")
                                : Math.trunc(unclaimPoints)}
                            </div>
                          </div>
                        </div>
                        <div
                          className="second"
                          onClick={() => getCommissionData()}
                          style={{ cursor: "pointer" }}
                        >
                          <VIcon
                            icon={themeIcons.refresh}
                            className="theme-icon-size-15"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="home-balance-commission-buttons mt-2">
                      {homeMenu3 &&
                        homeMenu3.length &&
                        map(homeMenu3, (item, index) => {
                          return (
                            <div
                              key={index}
                              className="home-bc-item"
                              onClick={() => _history.push(item.url)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="home-bc-item-wrapper">
                                <div className="first">
                                  <VIcon
                                    icon={item.icon}
                                    className="theme-icon-blue-size-20"
                                  />
                                </div>
                                <div className="second">{t(item.text)}</div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : ""
        }
        
        <div className="home-popular-section">
          <ul className="list-unstyled home-game-category">
            {gameCategories.map((category, index) => {
              return (
                <li
                  key={index}
                  className={classnames({
                    active: activeTab === category.id,
                  })}
                >
                  <a
                    className={classnames({
                      active: activeTab === category.id,
                    })}
                    onClick={() => {
                      toggleTab(category.id);
                    }}
                  >
                    <span className="category-text">{t(category.title)}</span>
                  </a>
                </li>
              );
            })}
          </ul>
          <div className="">
            <TabContent activeTab={activeTab}>
              {games.length == 0 && (
                <div className="spinner-wrapper">
                  <Spinner
                    animation="border"
                    role="status"
                    size="sm"
                    style={{
                      verticalAlign: "middle",
                      width: "2rem",
                      height: "2rem",
                    }}
                  >
                    <span className="sr-only">{t("LOADING")}...</span>
                  </Spinner>
                </div>
              )}
              {gameCategories.map((category, index) => {
                if (
                  games.filter((n) => n.categoryTitle === category.title)
                    .length > 0 ||
                  category.title === "All"
                ) {
                  return (
                    <TabPane key={index} tabId={category.id}>
                      <div className="home-service-provider pt-3">
                        {games.map((game, index) => {
                          if (
                            game["categoryTitle"] === category.title ||
                            category.title === "All"
                          ) {
                            return (
                              <div
                                className={"hsp-item" + (bonusWalletBalance>0 && !game["isPromotion"]?" promotion-disabled":"")}
                                key={"container-" + index}
                              >
                                 {
                                  index == 0 ||  index == 1 || index == 2 ? 
                                    (<div className="hot-tag"></div>) : ""
                                }
                                <a
                                  key={index}
                                  className="d-block"
                                  onClick={() => {
                                    if (isLoggedIn) {
                                        
                                      if(bonusWalletBalance>0 && !game["isPromotion"])
                                      {
                                        _dispatch(
                                            showMessage({
                                                type: AlertTypes._WARNING,
                                                content: t("GAME_NOT_FOR_ACTIVE_BONUS"),
                                            })
                                        );
                                      }
                                      else
                                      {
                                          setPopupBannerImage(
                                            game["popupBannerImage"]
                                          );
                                          if (game["gameUm"] !== true) {
                                            startGame(
                                              game["id"],
                                              game["hasOwnLobby"],
                                              game["masterProductId"],
                                              game["gameName"],
                                              game["masterProductIsSeamless"],
                                              game["isApp"],
                                              game["appUrl"],
                                              game["appDeepLink"],
                                              game["isNewWindow"],
                                              game["packageNameKeyword"],
                                              game["categoryTitle"]
                                            );
                                          }
                                      }
                                    } else {
                                      _dispatch(
                                        showMessage({
                                          type: AlertTypes._WARNING,
                                          content: t("PLEASE_LOGIN_FIRST"),
                                        })
                                      )
                                    }
                                  }
                                  }

                                >
                                  <img
                                    className="img-100"
                                    src={game["image"]}
                                    alt={game["gameName"]}
                                  />
                                  {game["gameUm"] == true && (
                                    <>
                                      <div
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        className="v2-um-tag game-category-label"
                                      ></div>
                                      <div
                                        style={{
                                          backgroundImage: `url("${UMIcon2}")`,
                                        }}
                                        className="v2-um-tag-icon"
                                      ></div>
                                    </>
                                  )}
                                  <div className="gamelist-name text-white">
                                    {game["gameName"]}
                                  </div>
                                </a>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </TabPane>
                  );
                }
              })}
            </TabContent>
          </div>
        </div>

        <div className="mt-4">
          <h3 className="t3-custom-title mb-2">
            <span>{t("LIVE_CAP")}</span> {t("TRANSACTION")}
          </h3>
          <div className="mobile-latest-deposit-withdraw-box">
            <div>
              <div className="mobile-home-latest-transactions-box">
                <div className="head">
                  <div>{t("DEPOSIT")}</div>
                </div>
                {latestDepositList && latestDepositList.length > 0 ? (
                  map(latestDepositList, (item, index) => {
                    return (
                      <div key={index} className="body">
                        <div className="latest-label">
                          <img src={item.icon} />
                          {item.username}
                        </div>
                        <div>{item.amount.toFixed(2)}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="body empty-data">
                
                      <>
                        <img
                          src={require('../../../assets/img/no-data.png')}
                          className="img-responsive"
                          width={"60px"}
                          alt="icon"
                        /><p className="m-0">{t("NO_DATA_FOUND")}</p>
                      </> 
                    
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className="mobile-home-latest-transactions-box">
                <div className="head">
                  <div>{t("WITHDRAWAL")}</div>
                </div>
                {latestWithdrawalList && latestWithdrawalList.length > 0 ? (
                  map(latestWithdrawalList, (item, index) => {
                    return (
                      <div key={index} className="body">
                        <div className="latest-label">
                          <img src={item.icon} />
                          {item.username}
                        </div>
                        <div>{item.amount.toFixed(2)}</div>
                      </div>
                    );
                  })
                ) : (
                  <div className="body empty-data">
                      <>
                        <img
                          src={require('../../../assets/img/no-data.png')}
                          className="img-responsive"
                          width={"60px"}
                          alt="icon"
                        />
                      </>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {
          payoutList.length > 0 && (
            <div className="payout-container mt-4">
              <div>
                <h3 className="t3-custom-title mb-2">
                  <img className="gif" src={require("../../../assets/img/trophy-gif.gif")} /><span>{t("RECENT")}</span> {t("PAYOUT")}
                </h3>
                <div className="payout-list">
                  <Slider {...payoutSlick}>
                    {
                      map(payoutList, (item, index) => {
                        return (
                          <div key={index}>
                            <div className="item">
                              <div className="item-sub-box">
                                <img src={item.image} />
                                <div>
                                  <div className="title">{item.game}</div>
                                  <div className="username">{item.username}</div>
                                </div>
                              </div>
                              <div className="amount">${item.winning}</div>


                            </div>

                          </div>
                        )
                      })
                    }

                  </Slider>

                </div>
              </div>
            </div>
          )
        }

        <div className="home-promo-vip-container">
          <div
            onClick={() => _history.push(WebUrl._URL_FS_PROMOTION)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../../assets/img/home/new/Promotion02.png")}
              alt="promotion"
            />
            <div className="home-promo-and-vip-details">
              <a>{t("PROMOTIONS")}</a>
            </div>
          </div>
          <div
            onClick={() => _history.push(WebUrl._URL_VIP_BENEFITS)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../../assets/img/home/new/VIP_Event02.png")}
              alt="promotion"
            />
            <div className="home-promo-and-vip-details">
              <a>{t("VIP_PROGRAM")}</a>
            </div>
          </div>
        </div>
        <div className="home-promo-vip-container" style={{ marginTop: "20px" }}>
          <div
            onClick={() => _history.push(WebUrl._URL_COMMISSIONS_INFO)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../../assets/img/home/new/Commission02.png")}
              alt="promotion"
            />
            <div className="home-promo-and-vip-details">
              <a>{t("COMMISSION")}</a>
            </div>
          </div>
          
          <div
            onClick={() => _history.push(WebUrl._URL_RECENT_BIG_WIN)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../../assets/img/home/new/recent-big-win.jpg")}
              alt="promotion"
            />
            <div className="home-promo-and-vip-details">
              <a>{t("RECENT_BIG_WIN")}</a>
            </div>
          </div>
        </div>
      </div>

      {showPinEntry && (
        <div>
          <div className="pin-wrapper"></div>
          <div className="pin-number">
            <button
              type="button"
              style={{
                alignSelf: "flex-end",
                backgroundColor: "transparent",
                border: "none",
                marginRight: "15px",
                fontSize: "2rem",
                color: "#002e6c",
                marginTop: "-15px",
                float: "right",
                fontWeight: "bold",
              }}
              onClick={() => {
                clearInterval(theInterval);
                setShowPinEntry(false);
              }}
              data-dismiss="modal"
              aria-hidden="true"
            >
              &times;
            </button>
            <strong
              className="reload-title text-yellow mb-3 d-block"
              style={{ fontSize: "20px", marginLeft: "40px" }}
            >
              {t("ENTER_YOUR_PIN")}
            </strong>
            <PinInput
              style={{ marginBottom: "35px" }}
              ref={eleFinalPin}
              length={4}
              initialValue=""
              secret={true}
              focus={showPinEntry}
              autoSelect={false}
              disabled={showPinEntry}
              onChange={(value, index) => {
                setPinNumberFinalFocused(index);
              }}
              type="numeric"
              inputMode="number"
              inputStyle={{
                border: "0",
                margin: "0px 10px",
                width: "40px",
                height: "40px",
                backgroundColor: "transparent",
                borderBottom: "2px solid #002e6c",
              }}
              inputFocusStyle={{ borderBottom: "2px solid #FFC159" }}
              regexCriteria={/^[ 0-9_@./#&+-]*$/}
            />

            <strong
              className="text-brand display-value"
              style={{ cursor: "pointer" }}
              onClick={() => {
                sendPinCode();
              }}
            >
              {t("RESET_PIN")}
            </strong>
            {smsSent && (
              <p
                className="text-brand"
                style={{ textAlign: "center", marginTop: "5px" }}
              >
                {t("PIN_SENT")} {t("RESEND_IN")} {countdownPeriod} {t("SECOND")}
              </p>
            )}
            {showAlert && (
              <div
                className="content content-full-width"
                style={{
                  position: "fixed",
                  top: "10px",
                  left: "0",
                  width: "100%",
                }}
              >
                <div className="container">
                  <Alert color="danger">{t("WAIT_TO_RESEND")}</Alert>
                </div>
              </div>
            )}
            <div
              className="invalid-feedback"
              style={{ fontSize: "12px", marginTop: "1rem" }}
            >
              {invalidPin && t(errorMessage)}
              {!invalidPin && <span>&nbsp;</span>}
            </div>
            <Keyboard
              layout={{
                default: ["1 2 3 4 5 6 7 8 9 &nbsp; 0 {bksp}"],
              }}
              display={{
                "{bksp}":
                  '<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path fill="#FFFFFF" d="M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"/></svg>',
              }}
              theme={`keyboard keyboard-numpad`}
              keyboardRef={(r) => (keyboard.current = r)}
              onKeyPress={onVerifyPinKeyPress}
              disableButtonHold
              disableCaretPositioning
            />
          </div>
        </div>
      )}
      <Modal
        id="dashboard-pregame-popup"
        fade={false}
        contentClassName="modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal"
        isOpen={showPregamePopup}
        toggle={() => {
          setShowPregamePopup(false);
          SetToLobbyBtn(false);
          setShowAppCred(false);
        }}
        centered
      >
        <ModalBody>
          <div id="game-lobby-new">
            <div className="top-title-right mb-3">
              <div className="content-header home-header shared-header modern-header">
                <div className="top-header">
                  <div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-icon"
                        onClick={() => {
                          setShowPregamePopup(false);
                          SetToLobbyBtn(false);
                          setShowAppCred(false);
                        }}
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </div>
                    <div
                      className="text-lblue1 text-underline"
                      onClick={() => {
                        setShowPregamePopup(false);
                        SetToLobbyBtn(false);
                        setShowAppCred(false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("CANCEL")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="">
              <h3 className="mb-3">{selectedGameName}</h3>
              <div className="gamelobby-banner">
                {!stringIsNullOrEmpty(popupBannerImage) ? (
                  <img
                    src={popupBannerImage}
                    className="img-100 border-radius-10"
                    alt="banner"
                  />
                ) : (
                  <img
                    src={require("../../../assets/img/game/jj-banner.png")}
                    className="img-100 border-radius-10"
                    alt="banner"
                  />
                )}
              </div>
            </div>
            {!selectedGameIsSeamless && (
              <>
                <div className="wallet-notice">
                  <img src={require('../../../assets/img/notice-icon.png')} />
                  {isBonusWallet ? t('NOTICE_BONUS_WALLET') : t('NOTICE_MAIN_WALLET')}
                </div>
                <div className="home-balance-com-box mt-3">
                  <div className={`hbc-box bg-lblue ${isBonusWallet ? "" : "box-active"}`}>
                    <div className="first">
                      <div className="hbc-label font12 text-lgray4">
                        {t("MAIN_WALLET")}
                      </div>
                      <div className="hbc-balance font14 f-weight-500">
                        {fromOptions.length > 0
                          ? numberWithCurrencyFormat(currentWalletBalance, 2)
                          : ""}
                      </div>
                    </div>
                    <div className="second-wrapper">
                      <div className="second">
                        <VIcon
                          icon={themeIcons.refresh}
                          className="theme-icon-blue-size-15"
                          onClick={() => {
                            setShowConfirmation(true);
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`hbc-box bg-lblue ${isBonusWallet ? "box-active" : ""}`}>
                    <div className="first">
                      <div
                        className="hbc-label font12 text-lgray4"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {t("BONUS_WALLET")}
                      </div>
                      <div className="hbc-balance font14 f-weight-500">
                        {toOptions.length > 0
                          ? numberWithCurrencyFormat(bonusWalletBalance, 2)
                          : ""}
                      </div>
                    </div>
                    <div className="second-wrapper">
                      <div className="second">
                        <VIcon
                          icon={themeIcons.refresh}
                          className="theme-icon-blue-size-15"
                          onClick={() => {
                            setShowConfirmation(true);
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="home-balance-com-box mt-3">
                  <div className="hbc-box bg-lblue">
                    <div className="first">
                      <div className="hbc-label font12 text-lgray4">
                        {t("COMMISSION")}
                      </div>
                      <div className="hbc-balance font14 f-weight-500">
                        {!isObjectEmpty(productCommRate)
                          ? productCommRate.playerComm.toFixed(2)
                          : "0.00"}
                        %
                      </div>
                    </div>
                    <div className="second-wrapper">
                      <div className="second">
                        <VIcon
                          icon={themeIcons.dashboardCommission}
                          className="theme-icon-blue-size-20"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="hbc-box bg-lblue">
                    <div className="first">
                      <div className="hbc-label font12 text-lgray4">
                        {t("VIP_COMMISSION")}
                        <Tooltip
                          className="wallet-tooltip"
                          placement="top"
                          isOpen={tooltipOpen}
                          autohide={false}
                          target="tooltipInfo"
                          toggle={toggle}
                        >
                          {
                            map(commissionInfo, (item) => {
                              return (
                                <div>
                                  {t(item.content)} : {item.value.toFixed(2)}%
                                </div>
                              )
                            })
                          }
                        </Tooltip>
                        <VIcon
                          id="tooltipInfo"
                          icon={themeIcons.info}
                          className="wallet-info-icon"
                        />
                      </div>
                      <div className="hbc-balance font14 f-weight-500">
                        {productCommRate.categoryName == "Slots"
                          ? memberData["vipInfo"]?.["rebateSlot"].toFixed(2)
                          : productCommRate.categoryName == "Sports"
                            ? memberData["vipInfo"]?.["rebateSport"].toFixed(2)
                            : productCommRate.categoryName == "Fish"
                              ? memberData["vipInfo"]?.["rebateFish"].toFixed(2)
                              : productCommRate.categoryName == "Lottery"
                                ? memberData["vipInfo"]?.["rebateLottery"].toFixed(2)
                                : memberData["vipInfo"]?.["rebateCasino"].toFixed(2)}
                        %
                      </div>
                    </div>
                    <div className="second-wrapper">
                      <div className="second">
                        <div className="vip-icon-wallet" style={{
                          backgroundImage: `url("${memberData["vipInfo"]?.["vipModel"]?.["icon"]}")`,
                        }}></div>
                      </div>
                    </div>
                  </div>
                </div>
                {isBonusWallet &&
                  <div>
                    <div className="home-balance-com-box mt-3">
                      <div className="hbc-box bg-lblue">
                        <div className="first" style={{ width: "100%" }}>
                          <div className="bonus-container" >
                            <div className="hbc-label font12 text-lgray4">
                              {bonusTarget > 0 ? t("BONUS_TARGET") : t("NO_TARGET")}
                            </div>
                            {bonusTarget > 0 &&
                              <span className="font10 text-lgray2">
                                {numberWithCurrencyFormat(
                                  bonusWalletBalance,
                                  2,
                                  true
                                )}{" "}
                                /{" "}
                                {numberWithCurrencyFormat(
                                  parseFloat(bonusTarget),
                                  2,
                                  true
                                )}
                              </span>
                            }

                          </div>

                          <div className="rollover-balance-box2">
                            <div className="progress-bar-box-deposit-promotion mt-1 mb-1c">
                              {bonusTarget > 0 &&
                                <span
                                  className="progress-identifier"
                                  style={{
                                    width:
                                      bonusWalletBalance == 0
                                        ? "0%"
                                        : (bonusWalletBalance /
                                          bonusTarget) *
                                        100 +
                                        "%",
                                  }}
                                ></span>
                              }
                              {bonusTarget == 0 &&
                                <span
                                  className="progress-identifier"
                                  style={{
                                    width: "100%"
                                  }}
                                ></span>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="hbc-box bg-lblue">
                        <div className="first" style={{ width: "100%" }}>
                          <div className="bonus-container" >
                            <div className="hbc-label font12 text-lgray4">
                              {t("BONUS_ROLLOVER")}
                            </div>
                            <span className="font10 text-lgray2">
                              {numberWithCurrencyFormat(
                                parseFloat(rolloverTarget - rolloverBalance),
                                2,
                                true
                              )}{" "}
                              /{" "}
                              {numberWithCurrencyFormat(
                                parseFloat(rolloverTarget),
                                2,
                                true
                              )}
                            </span>
                          </div>
                          <div className="rollover-balance-box2">
                            <div className="progress-bar-box-deposit-promotion mt-1 mb-1c">
                              <span
                                className="progress-identifier"
                                style={{
                                  width:
                                    rolloverTarget == rolloverBalance
                                      ? "0%"
                                      : ((rolloverTarget - rolloverBalance) /
                                        rolloverTarget) *
                                      100 +
                                      "%",
                                }}
                              ></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {bonusWalletBalance < 0.2 &&
                      <button
                        type="button"
                        onClick={() => {
                          setShowEndPromoConfirmation(true)

                        }}
                        className="btn btn-custom font20 mt-4"
                      >
                        {t("END_PROMO")}
                      </button>
                    }
                    {bonusWalletBalance > 0.2 &&
                      <button
                        type="button"
                        onClick={() => ((rolloverBalance === 0 && ((bonusTarget > 0 && bonusTarget <= bonusWalletBalance || bonusTarget == 0))) || bonusWalletBalance < 0.2) && getRestoreAccountBlance()}
                        className={"btn btn-custom font20 mt-4 " + (((rolloverBalance === 0 && ((bonusTarget > 0 && bonusTarget <= bonusWalletBalance || bonusTarget == 0))) || bonusWalletBalance < 0.2) ? "" : "unavailable")}

                      >
                        {t("CLAIM_USD").replace("{0}", numberWithCurrencyFormat(parseFloat((maxWithdraw == 0 ? bonusWalletBalance : maxWithdraw)), 2, true)).toString()}
                      </button>
                    }
                  </div>

                }
                {promotionList.length > 0 &&
                  <div className="promotion-container mt-4">
                    <h4>{t("PROMOTIONS")}</h4>
                    <div className="promotion-content promotion-content-flex">
                      {promotionList.length > 0 && map(promotionList, (item2, index) => {
                        return (
                          <div className={`fs-promotion-item ${item2.isActived ? "is-active" : ""}`} onClick={() => {
                            setSelectedPromo(item2)
                            setShowPromo(true);

                          }} >
                            <img
                              src={item2.image}
                              className={(item2.isEntitled && item2.isPromoCleared ) || item2.isActived ? "img-responsive" : "img-responsive unavailable-image"}
                              alt={item2.name}
                            />
                          </div>
                        )
                      })}
                    </div>
                  </div>
                }
                {selectedGameName == "Pussy888" ||
                  selectedGameName == "Mega888" ||
                  selectedGameName == "Evo888" ||
                  selectedGameName == "918Kiss" ? (
                  <div className="mt-3">
                    <p
                      style={{
                        color: "#ff1a1a",
                        fontSize: "12px",
                        lineHeight: "17px",
                      }}
                    >
                      {t("PRODUCT_ROLLOVER_MESSAGE")}
                    </p>
                  </div>
                ) : null}
                {isTransferSuccess && (
                  <div className="mt-3 reminder-green">
                    <div className="first">
                      <div className="first">
                        <img
                          src={require("../../../assets/img/new_icons/green.png")}
                          className="img-responsive"
                          alt="icon"
                        />
                      </div>
                      <div>
                        <p className="font14 mb-0 f-weight-500">
                          {t("TRANSFER_BALANCE_SUCCESS")}!
                        </p>
                        <p className="font12 mb-0">
                          {t("YOUR_ACCOUNT_BALANCE_IS_UPDATED")}.
                        </p>
                      </div>
                    </div>
                    {
                      <div
                        className="second"
                        onClick={() => setIsTransferSuccess(false)}
                        style={{ cursor: "pointer" }}
                      >
                        <p className="font12 mb-0">{t("OKAY")}</p>
                      </div>
                    }
                  </div>
                )}

                {!isApp || (isApp && appDeepLink != "") ? (
                  <>
                    {!toLobbyBtn ? (
                      <button
                        type="button"
                        onClick={() => {
                          if (isValidForPromotion) {
                            setShowPromotionConfirmation(true);
                          } else {
                            startGame2(productGameId, selectedGameName, selectedGameIsSeamless, isNewWindow)
                          }
                        }}
                        className="btn btn-custom font20 mt-4"
                      >
                        {t("START_GAME")}
                      </button>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                          JSON.stringify({ url: appUrl })
                        );
                      } else {
                        window.open(appUrl);
                      }
                    }}
                    className="btn btn-custom font20 mt-4"
                  >
                    {t("DOWNLOAD_APP")}
                  </button>
                )}
                {showAppCred && (
                  <div className="report-final-balance-box mt-3">
                    <div
                      className="earn-stat-title mt-2"
                      style={{ position: "relative" }}
                    >
                      <div className="details-label">
                        {t("USERNAME") + " : "}
                        <input
                          className="app-login-cred-text-box ml-2"
                          type="text"
                          value={appUsername}
                          ref={usernameRef}
                          readOnly
                        />
                      </div>

                      <div
                        onClick={() => copyText("username")}
                        style={{ cursor: "pointer" }}
                      >
                        <Icon path={mdiContentCopy} size={1} color="#cbd5e1" />
                      </div>
                    </div>
                    <div
                      className="earn-stat-title mt-2"
                      style={{ position: "relative" }}
                    >
                      <div className="details-label">
                        {t("PASSWORD") + " : "}
                        <input
                          className="app-login-cred-text-box ml-2"
                          type="text"
                          value={appPassword}
                          ref={passwordRef}
                          readOnly
                        />
                      </div>

                      <div
                        onClick={() => copyText("password")}
                        style={{ cursor: "pointer" }}
                      >
                        <Icon path={mdiContentCopy} size={1} color="#cbd5e1" />
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            {selectedGameHasOwnLobby &&
              gameList &&
              gameList["data"] &&
              gameList["data"].length > 0 && (
                <>
                  {gameList["data"].filter((x) => x.isRecommended) > 0 && (
                    <div className="mt-3">
                      <h3>Hot Games</h3>
                      <div className="home-service-provider mt-3 mb-3">
                        {map(
                          gameList["data"].filter((x) => x.isRecommended),
                          (item, index) => {
                            return (
                              <div key={index} className="hsp-item">
                                <a>
                                  <img
                                    src={item.image}
                                    className="img-100"
                                    alt="icon"
                                  />
                                  <div className="gamelist-name text-white">
                                    {item.gameName}
                                  </div>
                                </a>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  )}
                  {gameList["data"].filter((x) => !x.isRecommended).length >
                    0 && (
                      <div className="mt-3">
                        <h3>More Games</h3>
                        { }
                        <Nav className="nav nav-tabs mb-3 mt-3" id="my-tabs">
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: gameActiveTab === _FIRST_TAB,
                              })}
                              onClick={(e) => {
                                e.preventDefault();
                                setGameActiveTab(_FIRST_TAB); //todo
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              All Games
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: gameActiveTab === _SECOND_TAB,
                              })}
                              onClick={(e) => {
                                e.preventDefault();
                                setGameActiveTab(_SECOND_TAB);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              Slots
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <div className="search-box">
                          <div className="search-with-icon-box">
                            <div className="search-icon">
                              <VIcon
                                icon={themeIcons.search}
                                className="theme-icon-size-20"
                              />
                            </div>
                            <input type="text" placeholder="Search games..." />
                          </div>
                        </div>
                        <TabContent activeTab={gameActiveTab}>
                          <TabPane tabId={_FIRST_TAB}>
                            <div className="home-service-provider mt-4 mb-3">
                              {gameList["data"].filter((x) => !x.isRecommended)
                                .length > 0 &&
                                map(
                                  gameList["data"].filter(
                                    (x) => !x.isRecommended
                                  ),
                                  (item, index) => {
                                    return (
                                      <div key={index} className="hsp-item">
                                        <a
                                          onClick={() => {
                                            if (isValidForPromotion) {
                                              setShowPromotionConfirmation(true);
                                            } else {
                                              startGame2(productGameId, selectedGameName, selectedGameIsSeamless, isNewWindow)
                                            }

                                          }}
                                        >
                                          <img
                                            src={item.image}
                                            className="img-100 border-radius-10"
                                            alt="icon"
                                          />
                                          <div className="gamelist-name text-white">
                                            {item.gameName}
                                          </div>
                                        </a>
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </TabPane>
                          <TabPane tabId={_SECOND_TAB}>
                            <div className="home-service-provider mt-4 mb-3">
                              {gameList["data"].filter((x) => !x.isRecommended)
                                .length > 0 &&
                                map(
                                  gameList["data"].filter(
                                    (x) => !x.isRecommended
                                  ),
                                  (item, index) => {
                                    return (
                                      <div key={index} className="hsp-item">
                                        <a href={item.link}>
                                          <img
                                            src={item.image}
                                            className="img-100"
                                            alt="icon"
                                          />
                                          <div className="gamelist-name text-white">
                                            {item.gameName}
                                          </div>
                                        </a>
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    )}
                </>
              )}
            <Modal
              fade={false}
              contentClassName={
                "modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal"
              }
              isOpen={transferShow}
              toggle={() => {
                setTransferShow(false);
              }}
              centered
            >
              <ModalBody>
                <form onSubmit={handleSubmitPopup(submitPopupForm)}>
                  <div className="top-title-right mb-3">
                    <div className="content-header home-header shared-header modern-header">
                      <div className="top-header">
                        <div>
                          <div>
                            <button
                              type="button"
                              className="btn btn-icon"
                              onClick={() => {
                                setTransferShow(false);
                                setToGameAmount(0);
                                setPromoId("");
                              }}
                            >
                              <i className="fa fa-angle-left"></i>
                            </button>
                          </div>
                          <div
                            className="text-lblue1 text-underline"
                            onClick={() => {
                              setTransferShow(false);
                              setToGameAmount(0);
                              setPromoId("");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {t("CANCEL")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 className="mb-3">{t("TRANSFER_BALANCE")}</h5>
                  <div className="mb-1 mt-3">
                    <span className="font12 text-lgray2">
                      {t("AMOUNT_TO_TRANSFER")}
                    </span>
                  </div>
                  <div className="urr-amount-box">
                    <div>
                      <input
                        type="text"
                        name="amount"
                        value={Number(toGameAmount).toFixed(2)}
                        placeholder={numberWithCurrencyFormat(
                          parseFloat(toGameAmount),
                          2,
                          true
                        )}
                        className="input-with-balance"
                        onChange={(e) => {
                          let amount = e.target.value
                            .replace(
                              /[a-zA-Z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?(kr|$||)]*/g,
                              ""
                            )
                            .trim();

                          let value = Number(parseFloat(amount) / 100).toFixed(
                            2
                          );
                          if (
                            parseFloat(value) >
                            parseFloat(fromOptions[0].amount)
                          ) {
                            value = fromOptions[0].amount;
                          }
                          e.target.setSelectionRange(
                            value.length,
                            value.length
                          );
                          setInputValue(value);
                          setToGameAmount(value);
                        }}
                        disabled={
                          fromOptions.length > 0 &&
                            fromOptions[0].amount >
                            numberWithCurrencyFormat(parseFloat(0), 2, true)
                            ? ""
                            : "disabled"
                        }
                      />
                    </div>
                    <span className="font10 text-lgray2">
                      {t("AVAILABLE_BALANCE")}
                      {fromOptions.length > 0
                        ? numberWithCurrencyFormat(fromOptions[0].amount, 2)
                        : ""}
                    </span>
                  </div>
                  <span className="font12 text-lgray2 justify-center mt-2">
                    {t("Min")}:{" "}
                    {promoId != ""
                      ? numberWithCurrencyFormat(
                        promoCodeList.filter(
                          (x) => x.id == parseInt(promoId)
                        )[0].minDeposit,
                        2,
                        true
                      )
                      : numberWithCurrencyFormat(1, 2, true)}
                  </span>
                  <div
                    className="all-box-with-icon mt-2"
                    onClick={() => {
                      setPromoShow(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="first">
                      <div>
                        <VIcon
                          icon={themeIcons.dashboardCommission}
                          className="theme-icon-blue-size-20"
                        />
                      </div>
                      <div className="font14 f-weight-500 text-lblue">
                        {promoId == ""
                          ? t("PROMO_CODE")
                          : promoCodeList.filter(
                            (x) => x.id == parseInt(promoId)
                          )[0].name}
                      </div>
                    </div>
                    <div>
                      <VIcon
                        icon={themeIcons.angleRight}
                        className="theme-icon-blue-size-20"
                      />
                    </div>
                  </div>
                  {promoId != null &&
                    promoCodeList
                      .filter((x) => x.id == parseInt(promoId))
                      .map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="reports-stats-box mb-3 mt-4"
                          >
                            <div className="ro-box-1-1">
                              <div className="earn-stat-title mb-1">
                                <div className="first-title">
                                  {t("BONUS")} %
                                </div>
                                <div className="d-flex align-items-center"></div>
                              </div>
                              <div
                                className="earn-stat-number mb-1"
                                style={{ textAlign: "right" }}
                              >
                                {" "}
                                {item.bonus}
                              </div>
                            </div>

                            <div className="ro-box-1-1">
                              <div className="earn-stat-title mb-1">
                                <div className="first-title">Rollover</div>
                              </div>
                              <div
                                className="earn-stat-number mb-1"
                                style={{ textAlign: "right" }}
                              >
                                {" "}
                                x{item.rollover}
                              </div>
                            </div>
                          </div>
                        );
                      })}

                  <div className="mt-2">
                    {bonus > 0 && (
                      <>
                        <span className="font12 text-lgray2">
                          {t("BONUS")}:{" "}
                          {numberWithCurrencyFormat(parseFloat(bonus), 2, true)}
                          %
                        </span>
                        <br />
                      </>
                    )}
                  </div>
                  <div>
                    <button
                      type="submit"
                      className={
                        inputValue > 0
                          ? "btn btn-custom font20 mt-4"
                          : "btn btn-custom font20 mt-4 disabled"
                      }
                    >
                      {t("TRANSFER_TO_WALLET")}
                    </button>
                  </div>
                </form>
              </ModalBody>
            </Modal>

            <Modal
              fade={false}
              contentClassName={
                "modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal"
              }
              isOpen={promoShow}
              toggle={() => {
                setPromoShow(false);
              }}
              centered
            >
              <ModalBody>
                <form>
                  <div className="top-title-right mb-3">
                    <div className="content-header home-header shared-header modern-header">
                      <div className="top-header">
                        <div>
                          <div>
                            <button
                              type="button"
                              className="btn btn-icon"
                              onClick={() => {
                                setPromoShow(false);
                              }}
                            >
                              <i className="fa fa-angle-left"></i>
                            </button>
                          </div>
                          <div
                            className="text-lblue1 text-underline"
                            onClick={() => {
                              setPromoShow(false);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {t("CANCEL")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <h5 className="mb-3">{t("PROMO_CODE")}</h5>
                  <div className="mb-1 mt-3">
                    <span className="font12 text-lgray2">
                      {t("SELECT_PROMO_CODE")}
                    </span>
                  </div>
                  <div
                    className="all-box-with-icon mt-2"
                    onClick={() => {
                      setPromoId("");
                      setPromoShow(false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="first">
                      <div>
                        <VIcon
                          icon={themeIcons.dashboardCommission}
                          className="theme-icon-blue-size-20"
                        />
                      </div>
                      <div className="font14 f-weight-500 text-lblue">
                        No bonus
                      </div>
                    </div>
                  </div>
                  {promoCodeList
                    .filter((x) => x.productId == masterProductId)
                    .map((promo, index) => {
                      return (
                        <div
                          key={index}
                          className="all-box-with-icon mt-2"
                          onClick={() => {
                            setPromoId(promo.id);
                            setPromoShow(false);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="first">
                            <div>
                              <VIcon
                                icon={themeIcons.dashboardCommission}
                                className="theme-icon-blue-size-20"
                              />
                            </div>
                            <div className="font14 f-weight-500 text-lblue">
                              {selectedGameName} - {promo.name}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </form>
              </ModalBody>
            </Modal>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        fade={false}
        contentClassName={
          "modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal" +
          (deviceType === "iPhone" ||
            deviceType === "iPad" ||
            deviceType === "MacPPC" ||
            deviceType === "MacIntel"
            ? " modal-dc"
            : "")
        }
        isOpen={showDCPopup}
        toggle={() => {
          setShowDCPopup(false);
        }}
        centered
      >
        <ModalBody>
          <div className="top-title-right mb-3">
            <div className="content-header home-header shared-header modern-header">
              <div className="top-header">
                <div>
                  <div>
                    <button
                      type="button"
                      className="btn btn-icon"
                      onClick={() => {
                        setShowDCPopup(false);
                      }}
                    >
                      <i className="fa fa-angle-left"></i>
                    </button>
                  </div>
                  <div
                    className="text-lblue1 text-underline"
                    onClick={() => {
                      setShowDCPopup(false);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {t("CANCEL")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ bottom: "10px", position: "relative" }}>
            <h3 className="mb-2">{t("LOGIN_BONUS")}</h3>
            <p className="font14 mb-4 text-lgray2">
              {t("COME_BACK_DAILY_TO_EARN_YOUR_REWARD")}
            </p>
          </div>
          <div className="daily-check-in-container-items text-center">
            <div
              className="text-center font-14 text-white"
              style={{ marginTop: "10px" }}
            >
              {t("AVAILABLE_POINTS")} :{" "}
              {Math.trunc(memberData["memberPoints"])
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            </div>
            <div
              className="text-center font-14 text-white mb-4"
              style={{ marginTop: "10px" }}
            >
              {t("DAILY_REWARDS")}
            </div>
            <div className="daily-check-in">
              {dCRate &&
                dCRate.length > 0 &&
                map(dCRate, (item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        !claimed && activeIndex == index + 1
                          ? "daily-check-in-items active"
                          : "daily-check-in-items"
                      }
                      onClick={() => {
                        if (activeIndex == index + 1) {
                          handleSubmitDC(item);
                        }
                      }}
                      style={{
                        cursor:
                          activeIndex == index + 1 ? "pointer" : "default",
                      }}
                    >
                      <div className="daily-check-in-wrapper">
                        <div className="daily-check-in-top-icon">
                          {!claimed && activeIndex == index + 1 ? (
                            <img
                              src={require("../../../assets/img/daily_check_in/polygon-green.svg")}
                              alt="day-icon"
                              className="day-icon"
                            />
                          ) : item.isBigPrize ? (
                            <img
                              src={require("../../../assets/img/daily_check_in/polygon-color.svg")}
                              alt="day-icon"
                              className="day-icon"
                            />
                          ) : (
                            <img
                              src={require("../../../assets/img/daily_check_in/polygon-transparent.svg")}
                              alt="day-icon"
                              className="day-icon"
                            />
                          )}
                          <span className="day-index">{index + 1}</span>
                        </div>
                        <div className="center-box">
                          <div
                            className={
                              item.isBigPrize
                                ? !claimed &&
                                  item.isBigPrize &&
                                  activeIndex == index + 1
                                  ? "animated-border-box-glow color-border animate"
                                  : "animated-border-box-glow color-border"
                                : !claimed &&
                                  countdownText != "" &&
                                  activeIndex == index + 1
                                  ? "animated-border-box-glow yellow-border animate"
                                  : !claimed && activeIndex == index + 1
                                    ? "animated-border-box-glow white-border animate"
                                    : "animated-border-box-glow white-border"
                            }
                          ></div>
                          <div
                            className={
                              item.isBigPrize
                                ? !claimed &&
                                  item.isBigPrize &&
                                  activeIndex == index + 1
                                  ? "animated-border-box color-border animate"
                                  : "animated-border-box color-border"
                                : !claimed &&
                                  countdownText != "" &&
                                  activeIndex == index + 1
                                  ? "animated-border-box yellow-border animate"
                                  : !claimed && activeIndex == index + 1
                                    ? "animated-border-box white-border animate"
                                    : "animated-border-box white-border"
                            }
                          >
                            <div
                              className={
                                item.isBigPrize
                                  ? "daily-check-in-middle-icon color-border"
                                  : !claimed &&
                                    countdownText != "" &&
                                    activeIndex == index + 1
                                    ? "daily-check-in-middle-icon yellow-border"
                                    : "daily-check-in-middle-icon white-border"
                              }
                            >
                              <div className="daily-check-in-assets-icon">
                                {item.isBigPrize && (
                                  <img
                                    src={require("../../../assets/img/daily_check_in/diamond.svg")}
                                    alt="icon"
                                  />
                                )}
                                {!item.isBigPrize && (
                                  <img
                                    src={require("../../../assets/img/daily_check_in/coin.svg")}
                                    alt="icon"
                                  />
                                )}
                                {claimed && index + 1 <= activeIndex && (
                                  <img
                                    src={require("../../../assets/img/daily_check_in/check.svg")}
                                    alt="icon"
                                  />
                                )}
                              </div>
                            </div>
                            <div className="daily-check-in-day-pts">
                              <span>{item.points + " " + t("PTS")}</span>
                            </div>
                            {!claimed &&
                              countdownText != "" &&
                              activeIndex == index + 1 ? (
                              <div
                                className="daily-check-in-day-label"
                                style={{
                                  background: "#FFB600",
                                }}
                              >
                                <div className="daily-check-in-label text-center shine">
                                  <span>
                                    <img
                                      src={require("../../../assets/img/daily_check_in/timer.svg")}
                                      alt="icon"
                                    />
                                    {countdownText}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="daily-check-in-day-label"
                                style={{
                                  background:
                                    !claimed && activeIndex == index + 1
                                      ? "#6FCB20"
                                      : item.isBigPrize
                                        ? "linear-gradient(90deg, #263869 0%, #7D34CD 100%)"
                                        : "#263869",
                                }}
                              >
                                <div
                                  className={
                                    !claimed && activeIndex == index + 1
                                      ? "daily-check-in-label text-center shine"
                                      : "daily-check-in-label text-center"
                                  }
                                >
                                  {claimed && index + 1 == activeIndex ? (
                                    <span
                                      style={{ textTransform: "uppercase" }}
                                    >
                                      {t("CLAIMED")}
                                    </span>
                                  ) : !claimed && activeIndex == index + 1 ? (
                                    <span
                                      style={{ textTransform: "uppercase" }}
                                    >
                                      {t("CLAIM")}
                                    </span>
                                  ) : (
                                    <span>{t(item.label)}</span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {((claimed && index + 1 == activeIndex) ||
                          index + 1 < activeIndex) && (
                            <div className="daily-checkin-inactive"></div>
                          )}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        fade={false}
        contentClassName={
          "modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal"
        }
        isOpen={qrModal && registerUrl}
        toggle={() => {
          setQRModal(false);
        }}
        centered
      >
        <ModalBody>
          <div>
            <div className="top-title-right mb-3">
              <div className="content-header home-header shared-header modern-header">
                <div className="top-header">
                  <div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-icon"
                        onClick={() => {
                          setQRModal(false);
                        }}
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </div>
                    <div
                      className="text-lblue1 text-underline"
                      onClick={() => {
                        setQRModal(false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("CANCEL")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {showCodeAlert && (
	            <div className="mt-3 mb-3 reminder-green">
		            <div className="first">
			            <div className="first">
				            <img
					            src={require("../../../assets/img/new_icons/green.png")}
					            className="img-responsive"
					            alt="icon"
				            />
			            </div>
			            <div>
				            <p className="font14 mb-0 f-weight-500">
					            {t("COPY_SUCCESS")}
				            </p>
				            {/* <p className="font12 mb-0">
					            {"URL : "}
					            <br />
					            {registerUrl}
				            </p> */}
			            </div>
		            </div>
	            </div>
            )}

            <div className="home-bc-item-wrapper pt-3 pb-3 referral-code-box text-center mb-4">
              <div className="font10 text-lgray4">{t("REFERRER")}</div>
              <div className="font20 f-weight-700 text-lblue">
                {memberData["username"]}
              </div>

              <div className="font10 text-lgray4">{t("REFERRAL_CODE")}</div>
              <div className="font20 f-weight-700 text-lblue">
                {memberData["referralCode"]} <div
											onClick={() => copyItem(memberData["referralCode"])}
											style={{ cursor: "pointer", display: "inline"}}
										>
											<img
												src={require("../../../assets/img/new_icons/copy.png")}
												className="img-responsive"
												alt="icon"
											/>
										</div>
              </div>
            </div>
            <div className="qr-wrpper text-center">
              <QRCode className="referral-qr-code" value={registerUrl} />
            </div>

            <div>
			    <div>
				    <div
					    className="btn btn-custom font20 mt-3"
					    onClick={() => copyUrl()}
					    style={{ cursor: "pointer" }}
				    >
					    {t("COPY_LINK")}
				    </div>

				    <div className="d-flex justify-content-center pt-3">
					    {ShareButton}
				    </div>
			    </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        fade={false}
        contentClassName={
          "modal-brand modal-bottom reload-bank-modal withdraw-accounts-modal"
        }
        isOpen={showPromo}
        toggle={() => {
          setShowPromo(false);
        }}
        centered
      >
        <ModalBody>
          <form>
            <div className="top-title-right mb-3">
              <div className="content-header home-header shared-header modern-header">
                <div className="top-header">
                  <div>
                    <div>
                      <button
                        type="button"
                        className="btn btn-icon"
                        onClick={() => {
                          setShowPromo(false);
                        }}
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </div>
                    <div
                      className="text-lblue1 text-underline"
                      onClick={() => {
                        setShowPromo(false);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("CANCEL")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="mb-3" style={{ borderBottom: "2px solid", paddingBottom: "10px" }}>{selectedPromo.name}</h3>
            <hr />
            <div
              style={{ paddingBottom: "57px" }}
              dangerouslySetInnerHTML={{ __html: selectedPromo.content }}
            />
            <div >
              <div className="fs-promo-info-button-container ">
                {!isInitLoaded && (
                  <div
                    className="width-100-p unavailable-image mb-3"
                    disabled="true"
                  >
                    <span className="btn btn-custom font20 mt-4">{t("CLAIM")}</span>
                  </div>

                )}
                {selectedPromo.isClaimable && isInitLoaded && (
                  <div
                    className={(selectedPromo.isEntitled && selectedPromo.isPromoCleared ) ? "width-100-p mb-3" : "width-100-p unavailable-image mb-3"}
                    disabled={(selectedPromo.isEntitled && selectedPromo.isPromoCleared ) ? false : true}
                    onClick={() => {
                      if (selectedPromo.isEntitled && selectedPromo.isPromoCleared ) {
                        claimPromotion(selectedPromo.id)

                      } else {
                        _dispatch(
                          showMessage({
                            type: AlertTypes._ERROR,
                            content: t(selectedPromo.reason),
                          })
                        );
                      }
                    }}>
                    <a className="btn btn-custom font20 mt-4">
                      {t("CLAIM")}
                    </a>
                  </div>
                )}
                <div className="width-100-p mb-3" >
                  <a className="btn btn-custom-close font16 mt-4" onClick={() => {
                    setSelectedPromo([])
                    setShowPromo(false);
                  }}>
                    {t("CLOSE")}
                  </a>
                </div>
              </div>
            </div>


          </form>
        </ModalBody>
      </Modal>

      {(getValuesPopup("toWallet") > 0 || currentInput) && (
        <Numpad
          currentBalance={_userData.walletBalance}
          currentInput={currentInput}
          setCurrentInput={(e) => {
            setCurrentInput(e);
          }}
        />
      )}
    </>
  );
};

export default Dashboard;
